import classes from "./TopBannersSection.module.less";

import { useTranslation } from "react-i18next";
import GlobalBanner from "~/Header/components/TopBannersSection/GlobalBanner/GlobalBanner";
import { SaleTag } from "../../../SalesCampaign/components/SaleTag/SaleTag";
import { SALES_CAMPAIGN_PAGE } from "~/utils/url/staticUrls";
import {
  getRemainingTimeLabel,
  isValidPageForSalesBanner,
  useActiveCampaignsNotInSmartEdit,
} from "~/Header/components/TopBannersSection/utils";
import { useSchaefflerTopBannerList } from "~/CMSComponents/components/SchaefflerTopBannerComponent";
import { Button } from "~/common/components/Button/Button";

import Parser from "html-react-parser";

export const TopBannersSection = () => {
  const { t } = useTranslation();
  const smartEditBanners = useSchaefflerTopBannerList();
  const campaignsNotInSmartEdit = useActiveCampaignsNotInSmartEdit();

  if (!isValidPageForSalesBanner(window.location.pathname)) {
    return null;
  }

  if (!smartEditBanners.length && !campaignsNotInSmartEdit.length) {
    // Nothing to show
    return null;
  }

  const smartEditBannerComponents = smartEditBanners.map((banner) => {
    const icon = banner.iconUrl ? <img className={classes.icon} src={banner.iconUrl} /> : undefined;
    const content: JSX.Element[] = banner.content ? (Parser(banner.content) as JSX.Element[]) : [];
    let remainingTimeLabel = "";
    if (banner.showRemainingTime && banner.campaign) {
      remainingTimeLabel = getRemainingTimeLabel(t, banner.campaign.endDate);
    }
    return (
      <GlobalBanner key={banner.uid} icon={icon}>
        <div className={classes.container}>
          {content} {remainingTimeLabel}
        </div>
      </GlobalBanner>
    );
  });

  let salesCampaignBanner = undefined;
  if (campaignsNotInSmartEdit.length) {
    const activeCampaign = campaignsNotInSmartEdit[0];
    salesCampaignBanner = (
      <GlobalBanner
        className={classes.salesCampaignBanner}
        icon={<SaleTag size={32} />}
        onClick={() => {
          window.location.href = `${SALES_CAMPAIGN_PAGE}`;
        }}
      >
        <div className={classes.bannerContent}>
          <p className={classes.bannerText}>{t("sales.campaign.top.banner.text")}</p>
          <Button className={classes.bannerBtn}>{t("sales.campaign.top.banner.btn")}</Button>
        </div>
      </GlobalBanner>
    );
  }

  return (
    <div className="scha__root-sales-banner">
      {smartEditBannerComponents}
      {salesCampaignBanner}
    </div>
  );
};
